const columns = [
  {
    title: '设计师',
    key: 'designerName',
    width: 86,
    type: 'basic'
  },
  {
    title: '项目组',
    key: 'projectGroupName',
    width: 98,
    type: 'basic'
  },
  {
    title: '新增视频数',
    key: 'addVideoCount',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '新增图片/组图数',
    key: 'addImageCount',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  }, {
    title: '外部视频数',
    key: 'externalMaterialCount',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  }, {
    title: '混剪视频数',
    key: 'mashupMaterialCount',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  }, {
    title: '原创视频数',
    key: 'originalMaterialCount',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '试玩',
    key: 'addPlayableCount',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '总账面消耗',
    key: 'paperUseAmount',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '总实际消耗',
    key: 'amount',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '新增账面消耗金额',
    key: 'newPaperUseAmount',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '新增实际消耗',
    key: 'newAmount',
    width: 95,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '新增30日消耗',
    key: 'totalAmount30',
    width: 95,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '新增30日创角',
    key: 'createRole30',
    width: 95,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '7日消耗',
    key: 'amount7',
    width: 74,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    width: 74,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    width: 106,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    width: 95,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '合格完成率',
    key: 'oneLevelRate',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '优秀完成率',
    key: 'twoLevelRate',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '卓越完成率',
    key: 'threeLevelRate',
    width: 82,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '超5万消耗素材数',
    key: 'fourLevelAmountCount',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '超10万消耗素材数',
    key: 'oneLevelAmountCount',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '超15万消耗素材数',
    key: 'twoLevelAmountCount',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '超50万消耗素材数',
    key: 'fiveLevelAmountCount',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '超100万消耗素材数',
    key: 'threeLevelAmountCount',
    width: 128,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '新增视频有效率',
    key: 'newImageOkRate',
    width: 106,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '合格KPI',
    key: 'oneLevelKpi',
    width: 80,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '优秀KPI',
    key: 'twoLevelKpi',
    width: 80,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '卓越KPI',
    key: 'threeLevelKpi',
    width: 80,
    type: 'basic',
    sortable: 'custom'
  }
]

const plannerColumns = columns.filter((col) => !['超50万消耗素材数'].includes(col.title))
const designerColumns = columns
export { plannerColumns, designerColumns }
